import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-shell',
  imports: [RouterOutlet, HeaderComponent],
  host: { class: 'block h-screen' },
  template: `
    <div class="flex h-full flex-col overflow-hidden bg-base-100">
      <app-header />
      <main class="flex-1 overflow-y-auto p-6">
        <router-outlet />
      </main>
    </div>
  `,
  styles: ``
})
export class ShellComponent {}
